import React from 'react';
import styled from '@emotion/styled';
import { getMobileOS } from '../../utilities/mobileRNApp';
import { APPLE_STORE_LINK, GOOGLE_STORE_LINK } from '../../constants/appStoreLinks';
import { openWindow } from '../../utilities/global';
import AlertIcon from './icons/AlertIcon.svg';
import ExternalArrow from './icons/ExternalArrow.svg';

const FullScreenSunsetModal = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  background-color: #49517d;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding: 10px;
`;

const SunsetModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fffbf0;
  border-width: 2px;
  border-color: #6a5901;
  border-radius: 8px;
  min-height: 200px;
  max-width: 95%;
  padding: 15px;
`;

const SunsetModalTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
`;

const SunsetModalTitle = styled.div`
  font-family: Roobert, sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #6a5901;
  padding-left: 10px;
`;

const SunsetDescriptionText = styled.div`
  display: block;
  font-family: Roobert, sans-serif;
  color: #6a5901;
  line-height: 20px;
  margin-bottom: 15px;
`;

const TextWithLink = styled.a`
  display: inline;
  color: #6a5901;
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-color: #6a5901;
  font-family: Roobert, sans-serif;
`;

const ButtonContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const GetAppButton = styled.div`
  display: flex;
  max-width: 300px;
  border-radius: 800px;
  flex-direction: row;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  align-items: center;
  background-color: #1f2647;
  color: #ffffff;
`;

const GetAppText = styled.div`
  color: #ffffff;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding-right: 5px;
  font-family: Roobert, sans-serif;
`;

const openAppStores = () => {
  const storeLink = getMobileOS() === 'android' ? GOOGLE_STORE_LINK : APPLE_STORE_LINK;

  const win = openWindow(storeLink);
  win?.focus();
};

const SunsetModal = () => {
  return (
    <FullScreenSunsetModal>
      <SunsetModalContainer>
        <SunsetModalTitleContainer>
          <AlertIcon color="#6A5901" />
          <SunsetModalTitle>This app no longer works</SunsetModalTitle>
        </SunsetModalTitleContainer>
        <SunsetDescriptionText>
          This app is no longer available. Please install our new app to monitor your system performance, manage your account, and get new features regularly.
          You can also use <TextWithLink href="https://my.sunrun.com/">my.sunrun.com</TextWithLink>.
        </SunsetDescriptionText>
        <ButtonContainer onClick={openAppStores}>
          <GetAppButton>
            <GetAppText>Get our new app </GetAppText>
            <ExternalArrow viewBox="0 0 15 15" width={15} height={16} color="#FFFFFF" />
          </GetAppButton>
        </ButtonContainer>
      </SunsetModalContainer>
    </FullScreenSunsetModal>
  );
};

export default SunsetModal;
